import { Component, Field } from '@contember/interface'

export const SocialLinkPreview = Component(() => (
	<div>
		<Field field="title" />
	</div>
))
